import * as api from './base';

// 杂志列表
export const list = (params) => api.get({
    url: "magazine/list?column=" + params.column + "&page=" + params.page,
    loading: "加载中"
});


//获取杂志介绍内容
export const getIntro = (params) => api.get({
	url: "Magazine/Intro",
	params,
	loading: "加载中"
})